<template>
    <partner-unauthorized  />
</template>

<script>

import partnerUnauthorized from 'partnerUnauthorized'
import quebecUserModal from '../mixins/QuebecUserModal'

export default {
    components: {
        partnerUnauthorized
    },
    watch: {
        $route: {
            immediate: true,
            handler () {
                if (this.$store.state.userProfile) {
                    this.$router.replace({ name: 'home' })
                }
            }
        }
    },
    mixins: [
        quebecUserModal
    ]
}
</script>
